<div class="twc-row align-center">
    <div class="twc-col-4">
        <span class="twc-body">{{'EXPORT_LAYER_DIALOG.EXPORT_FORMAT' | translate}} </span>
    </div>
    <div class="twc-col-8">
        <twc-select [(ngModel)]="formatValue" (ngModelChange)="onChange()">
            <twc-select-option *ngFor="let format of formatList" [value]="format">
                {{ format.label | translate}}
            </twc-select-option>
        </twc-select>
    </div>
</div>